import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { createMppData } from '@app/mpp/model/create-mpp-model';
import { MppService } from '@app/mpp/service/mpp.service';
import { ModalController, PopoverController } from '@ionic/angular';
import { PlatformEnum, PlatformService } from '@panamax/app-state';
import { LockInfoPopoverComponent } from '../../lock-info-popover/lock-info-popover.component';
import { firstValueFrom, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { HomeService } from '@app/home/services/home.service';

@Component({
  selector: 'app-create-mpp-modal',
  templateUrl: './create-mpp-modal.component.html',
  styleUrls: ['./create-mpp-modal.component.scss'],
})
export class CreateMppModalComponent implements OnInit {
  @Output() dismissEvent: EventEmitter<void> = new EventEmitter();
  @Output() submitEvent: EventEmitter<createMppData> = new EventEmitter();
  @Input() platform: PlatformEnum;
  @Input() data: createMppData;
  @Input() title: string;
  @Input() typeSelection: string;

  platformRef = PlatformEnum;
  nameContainsEmojis = false;
  descriptionContainsEmojis = false;
  length = 100;
  emojiRegex =
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
  showInfoText = false;
  duplicateNameIndicator = false;
  isInternal = false;

  constructor(
    private modalController: ModalController,
    readonly platformService: PlatformService,
    private mppService: MppService,
    private popoverController: PopoverController,
    private homeService: HomeService,
  ) {}

  options = [
    {
      image: '/assets/images/mpp_menu.svg',
      text: 'Menu Item',
      type: 'menuItem',
      selected: false,
    },
    {
      image: '/assets/images/mpp_recipe.svg',
      text: 'Recipe',
      type: 'recipe',
      selected: false,
    },
    {
      image: '/assets/images/mpp_event.svg',
      text: 'Event Menu',
      type: 'eventMenu',
      selected: false,
    },
  ];

  selectOption(option) {
    if (option.type === 'menuItem' || option.type === 'eventMenu') {
      return;
    }
    this.options.forEach(opt => (opt.selected = false));
    option.selected = true;
    this.data.type = option.type;
    if (this.data?.name) {
      this.duplicateNameIndicator = this.mppNameExists(
        this.data?.name,
        this.data?.type,
      );
    }
  }
  ngOnInit(): void {
    this.data = {
      type: '',
      name: '',
      description: '',
      lockIndicator: false,
      publicPermission: true,
    };
    this.options.forEach(option => {
      if (option.type === this.typeSelection) {
        option.selected = true;
        this.data.type = option.type;
      } else {
        option.selected = false;
      }
    });
    this.isInternalUser();
  }

  updateName() {
    this.data.name =
      this.data.name !== null && this.data.name.length > this.length
        ? this.data.name.substring(0, this.length)
        : this.data.name;
  }

  hasEmoji(text: string): boolean {
    return /\p{Extended_Pictographic}/gu.test(text);
  }

  onNameChange(text: string) {
    this.nameContainsEmojis = this.hasEmoji(text);
    this.duplicateNameIndicator = this.mppNameExists(text, this.data?.type);
  }

  /** Checks to see if the recipe name already exists */
  mppNameExists(name: string, type: string): boolean {
    let result = false;
    this.mppService.doesMppNameExists(name, type).then(res => {
      result = res;
      this.duplicateNameIndicator = result;
    });
    return result;
  }
  onDescriptionChange(text: string) {
    this.descriptionContainsEmojis = this.hasEmoji(text);
  }

  async dismiss() {
    await this.modalController.dismiss(true);
  }

  async createMpp() {
    if (!this.mppNameExists(this.data.name, this.data.type)) {
      this.mppService.handleCreateMppSubmission(this.data);
      await this.modalController.dismiss(true);
    }
  }

  closePopover = async () => {
    if (this.popoverController.getTop()) {
      await this.popoverController.dismiss();
    }
  };

  shouldCloselockInfoPopover(event: any) {
    window.addEventListener('blur', this.closePopover, { once: true });
  }

  removeWindowListener = () => {
    window.removeEventListener('blur', this.closePopover);
  };

  async isInternalUser() {
    this.isInternal = await firstValueFrom(this.homeService.isInternalUser());
  }
}
